import { createContext, useContext } from 'react'
import {
  changeSelectedEventsType,
  selectedEventsType
} from 'front-end/src/pages/manage-campaign-page/components/campaign-audience/modals/event-modal/event-selector/EventSelector'

type EventSelectorContextType = {
  selectedEvents: selectedEventsType
  changeSelectedEvents: changeSelectedEventsType
}

export const EventSelectorContext = createContext<EventSelectorContextType>({
  selectedEvents: {
    events: [],
    recEvents: []
  },
  changeSelectedEvents: () => {}
})

export const useEventSelectorContext = () => useContext(EventSelectorContext)
